import React from 'react';
import ReviewDetailsDesktop from './ReviewDetailsDesktop';
import ReviewDetailsMobile from './ReviewDetailsMobile';

const ReviewDetails = (props: any) => {
  const {
    isDesktop = false,
    reviewData,
    single,
    currentIndex = -1,
    updateSelectedImageIndex,
    renderSinglePhotoModal,
    productDetails = {},
    isFleek = false,
    ratingParityMsite = false
  } = props;
  return (
    <>
      {isDesktop ? (
        <ReviewDetailsDesktop
          reviewData={reviewData}
          single={single}
          currentIndex={currentIndex}
          updateSelectedImageIndex={updateSelectedImageIndex}
          renderSinglePhotoModal={renderSinglePhotoModal}
          productDetails={productDetails}
        />
      ) : (
        <ReviewDetailsMobile
          reviewData={reviewData}
          renderSinglePhotoModal={renderSinglePhotoModal}
          productDetails={productDetails}
          isFleek={isFleek}
          ratingParityMsite={ratingParityMsite}
        />
      )}
    </>
  );
};

export default ReviewDetails;
